import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import * as units from '../../../common/units';
import * as settings from '../../../common/settings';
import * as consts from '../../../common/consts';
import { TempDrawingObject } from '../../../asp/temp-drawings';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { inputValidation } from '@core_n/common/input-validation';
import { Animations } from './../../../Animations';

@Component({
  selector: 'app-dynamics',
  templateUrl: './dynamics.component.html',
  styleUrls: ['./../../aro.component.scss'],
  animations: [
    Animations.BlinkRedError
  ]
})
export class DynamicsComponent implements OnInit {
  @ViewChild('speedCircle', { read: ElementRef, static: true }) speedCircle: ElementRef;
  // type of track
  @Input() trackType: number; // 1 is abt 2 is tbm
  public trackTypeOld: number = 0;

  // window propertie and forms
  dynForm: FormGroup;
  public localUnits: number;

  // all dynamics patterns and properties
  // Masks and Validators
  maskCustomPatterns = {
    'X': { pattern: new RegExp(`[\\d]`) },
    'Y': { pattern: new RegExp(`[\\d-]`) },
    '0': { pattern: new RegExp(`[\\d.]`) },
    '1': { pattern: new RegExp(`1`) },
    'N': { pattern: new RegExp(`[NnSs]`) },
    'E': { pattern: new RegExp(`[EeWw]`) },
    'Z': { pattern: new RegExp(`[C-H|J-N|P-X|c-h|j-n|p-x]`) },
  }
  maskSpecialCharacters = [units.DEGREE_CHAR, ` `, `'`, `"`];
  maskAlt: string;
  validAlt = [Validators.required];
  maskSpd: string;
  validSpd = [Validators.required];
  maskHdg: string;
  validHdg = [Validators.required, Validators.max(360), Validators.min(0)];

  // Altitude
  public altitudeDis: string = "0";
  public altitudeUnits: string;
  public altitudeUnitsNum: settings.DisplayUnits;

  // graphics properties Altitude
  public altPercentGrad1;
  public altPercentGrad2;
  public altPercentActual; // actual altitude percentage
  public altPercentCutoff; // cutoff to transparent
  public altMinOpacity = 0.2;
  public altMaxOpacity = 0;

  // Speed
  //public speed: number;
  public speedDis: string = "0";
  public speedUnits: string;
  public speedUnitsNum: settings.DisplayUnits;

  // graphics properties Speed
  public speedCircleRadius: number;
  public speedCircleDasharray;
  public speedCircleDashoffset;

  // Heading
  //public heading: number;
  public headingDis: string = "0";

  // graphics properties Heading
  public headingRotate: string;

  // animations controls
  public state: boolean = false;
  tempMarker: TempDrawingObject = null;
  // altitude
  public activeErrAnimAlt = false;
  public errTransAlt = false;
  // speed
  public activeErrAnimSpd = false;
  public errTransSpd = false;
  // heading
  public activeErrAnimHdg = false;
  public errTransHdg = false;

  constructor(private fb: FormBuilder) {
    // get user settings of location and units
    this.localUnits = settings.userSettings.displayUnits;
    this.altitudeUnitsNum = settings.userSettings.displayUnits;
    this.altitudeUnits = units.altitudeUnitsVal(this.altitudeUnitsNum);
    this.speedUnitsNum = settings.userSettings.displayUnits;
    this.speedUnits = units.speedUnitsVal(this.speedUnitsNum);

    // Graphics Properties
    let hdgGauge = 180.0;
    this.headingRotate = `rotate(${hdgGauge}deg)`;

    this.maskAlt = `Y00000000||Y0000000||Y000000||Y00000||Y0000||Y000||Y00||Y0||Y`;
    this.maskSpd = `000000000||00000000||0000000||000000||00000||0000||000||00||0`;
    this.maskHdg = `000000000||00000000||0000000||000000||00000||0000||000||00||0`;
    // this.writeDynForm();

    this.dynForm = this.fb.group({
      alt: ['0', Validators.required],
      spd: ['0', Validators.required],
      hdg: [0, this.validHdg],
    });

    //setup refresh interval
    let self = this;
    setInterval(function () { self.refresh() }, consts.DIALOG_REFRESH_INTERVAL);
  }

  ngOnInit() {
    this.speedCircleRadius = this.speedCircle.nativeElement.r.baseVal.value;
    this.speedCircleDasharray = this.speedCircleRadius * 2.0 * Math.PI;
    this.speedCircleDashoffset = this.speedCircleDasharray;
  }

  protected refresh(): void {
    // if units got changed globally set local units to match
    if (this.localUnits != settings.userSettings.displayUnits) {
      this.localUnits = settings.userSettings.displayUnits;

      // this.dynForm.controls.hdg.setValue(val);

      this.altitudeUnitsNum = this.localUnits;
      this.altitudeUnits = units.altitudeUnitsVal(this.altitudeUnitsNum);
      this.dynForm.value.alt = units.altitudeValueFix(this.altitudeUnitsNum, this.dynForm.value.alt);
      this.dynForm.controls.alt.setValue(this.dynForm.value.alt);
      this.altitudeDis = this.globalStrDisplayFix(this.dynForm.value.alt);

      this.speedUnitsNum = this.localUnits;
      this.speedUnits = units.speedUnitsVal(this.speedUnitsNum);
      this.dynForm.value.spd = units.speedValueFix(this.speedUnitsNum, this.dynForm.value.spd);
      this.dynForm.controls.spd.setValue(this.dynForm.value.spd);
      this.speedDis = this.globalStrDisplayFix(this.dynForm.value.spd);
    }

    if (this.trackType != this.trackTypeOld) {
      this.trackTypeOld = this.trackType;
      this.updateAltitudeGraphics();
      this.updateSpeedGraphics();
    }

    // animation triggers and setters
    this.state = !this.state;

    //Altitude
    if (this.activeErrAnimAlt) { this.errTransAlt = this.state; }
    else { this.errTransAlt = false; }

    //Speed
    if (this.activeErrAnimSpd) { this.errTransSpd = this.state; }
    else { this.errTransSpd = false; }

    //Heading
    if (this.activeErrAnimHdg) { this.errTransHdg = this.state; }
    else { this.errTransHdg = false; }
  }

  // Handle individual Unit Changes and graphics
  updateAltitudeGraphics() {
    let alt: number = parseFloat(this.altitudeDis);
    if (this.altitudeUnitsNum == settings.DisplayUnits.Metric) {
      alt = units.altitudeValueFix(settings.DisplayUnits.Imperial, alt);
    }

    let altPercent = Math.round(alt / (this.trackType == 1 ? settings.MAX_ALT_FT : settings.MISSILE_MAX_FT) * 100.0);

    if (altPercent < 0)
      altPercent = 0;
    else if (altPercent > 100)
      altPercent = 100;

    this.altPercentActual = `${altPercent}%`;
    let altPercentCutoff = altPercent + 0.1;
    if (altPercentCutoff > 100)
      altPercentCutoff = 100;
    this.altPercentCutoff = `${altPercentCutoff}%`;

    let altPercentGrad1, altPercentGrad2;
    if (altPercent >= 20) {
      altPercentGrad2 = altPercent - 10;
      if (altPercentGrad2 < 0)
        altPercentGrad2 = 0;
      altPercentGrad1 = altPercent - 15;
      if (altPercentGrad1 < 0)
        altPercentGrad1 = 0;
    }
    else {
      altPercentGrad2 = altPercent * 0.5;
      altPercentGrad1 = altPercent * 0.25;
    }
    this.altPercentGrad2 = `${altPercentGrad2}%`;
    this.altPercentGrad1 = `${altPercentGrad1}%`;

    this.altMaxOpacity = altPercent == 100 ? 1 : 0;
    this.altMinOpacity = altPercent == 0 ? 0 : 0.2;
  }

  onAltitudeUnitChange() {
    this.altitudeUnitsNum = units.nextDisplayUnit(this.altitudeUnitsNum);
    this.altitudeUnits = units.altitudeUnitsVal(this.altitudeUnitsNum);
    this.dynForm.value.alt = units.altitudeValueFix(this.altitudeUnitsNum, this.dynForm.value.alt);
    this.dynForm.controls.alt.setValue(this.dynForm.value.alt);
    this.altitudeDis = this.globalStrDisplayFix(this.dynForm.value.alt);
  }

  updateSpeedGraphics() {
    let spd: number = parseFloat(this.speedDis);
    if (this.speedUnitsNum == settings.DisplayUnits.Metric) {
      spd = units.speedValueFix(settings.DisplayUnits.Imperial, spd);
    }
    let speedOffset = (1.0 - spd / (this.trackType == 1 ? settings.MAX_SPEED_KNOTS : settings.MISSILE_MAX_SPEED_KNOTS));
    if (speedOffset < 0)
      speedOffset = 0;
    this.speedCircleDashoffset = this.speedCircleDasharray * speedOffset;
  }

  onSpeedUnitChange() {
    this.speedUnitsNum = units.nextDisplayUnit(this.speedUnitsNum);
    this.speedUnits = units.speedUnitsVal(this.speedUnitsNum);
    this.dynForm.value.spd = units.speedValueFix(this.speedUnitsNum, this.dynForm.value.spd);
    this.dynForm.controls.spd.setValue(this.dynForm.value.spd);
    this.speedDis = this.globalStrDisplayFix(this.dynForm.value.spd);
  }

  onHeadingUnitChange() {
    // not in  use for now
  }

  globalStrDisplayFix(str: string) {
    if (str == "" || str == "NaN" || str == undefined || str == null) { return "0"; }

    let max: number = 5;
    if (str.includes('.')) { max = 6; }
    if (str.length > max) { str = str.substring(0, max); }
    return str;
  }

  checkValueValid(str: string) {
    if (str == undefined || str == null || str == "")
      return false;
    return true;
  }

  typingHandeling(e: InputEvent, type: string) {
    type = type.toLowerCase();
    switch (type) {
      case "alt": {
        this.activeErrAnimAlt = false;
        let val = inputValidation.fixAltitude(this.dynForm.value.alt, this.altitudeUnitsNum, e.data);
        this.dynForm.controls.alt.setValue(val);
        this.altitudeDis = this.globalStrDisplayFix(val);
        this.updateAltitudeGraphics();
        break;
      }
      case "spd": {
        this.activeErrAnimSpd = false;
        let val = inputValidation.fixSpeed(this.dynForm.value.spd, this.speedUnitsNum, e.data);
        this.dynForm.controls.spd.setValue(val);
        this.speedDis = this.globalStrDisplayFix(val);
        this.updateSpeedGraphics();
        break;
      }
      case "hdg": {
        this.activeErrAnimHdg = false;
        // let val = inputValidation.fixHeading(this.dynForm.value.hdg, e.data);
        // this.dynForm.controls.hdg.setValue(val);
        this.headingDis = this.globalStrDisplayFix(this.dynForm.value.hdg.toString());
        // update graphics
        let hdgGauge = parseFloat(this.headingDis) + 180.0;
        while (hdgGauge > 360)
          hdgGauge -= 360;
        this.headingRotate = `rotate(${hdgGauge}deg)`;
        break;
      }
    }
  }

  writeDynForm() {
    let defaultAlt = '';
    let defaultSpd = '';
    let defaultHdg = 0;

    this.dynForm.setValue({
      alt: defaultAlt,
      spd: defaultSpd,
      hdg: defaultHdg
    });
  }

  checkDynForm() {
    // chaeck values valid...
    let err: boolean = false;

    //Check Altitude
    if (!this.checkValueValid(this.dynForm.value.alt) || !this.dynForm.controls.alt.valid) {
      err = true;
      this.activeErrAnimAlt = true;
    }

    //Check Speed
    if (!this.checkValueValid(this.dynForm.value.spd) || !this.dynForm.controls.spd.valid) {
      err = true;
      this.activeErrAnimSpd = true;
    }

    //Check Heading
    if (!this.checkValueValid(this.dynForm.value.hdg.toString()) || !this.dynForm.controls.hdg.valid) {
      err = true;
      this.activeErrAnimHdg = true;
    }

    return err;
  }
}
